<template>
  <template-info :bgImg="bgImg" title="รายละเอียดแบบเต็ม">
    <div>
      <div class="pfb-detail">
        <div class="pfbd-sequence">1.</div>
        <div class="pfbd-description">
          กรณีไม่ชำระภาษีภายในกำหนดเวลา จะต้องเสียเงินเพิ่มอีกร้อยละ 1.5
          ต่อเดือน (เศษของเดือนให้นับเป็น 1 เดือน)
          ของเงินภาษีที่ต้องชำระนับแต่วันพ้นกำหนดเวลา
          การยื่นรายการจนถึงวันชำระภาษี
        </div>
      </div>

      <div class="pfb-detail">
        <div class="pfbd-sequence">2.</div>
        <div class="pfbd-description">
          กรณีเจ้าพนักงานตรวจสอบออกหมายเรียก
          และปรากฏว่ามิได้ยื่นแบบแสดงรายการไว้หรือ
          ยื่นแบบแสดงรายการไว้แต่ชำระภาษีขาดหรือต่ำไป <br /><br />

          นอกจากจะต้องรับผิดชำระเงินเพิ่มแล้ว ยังจะต้องรับผิดเสียเบี้ยปรับอีก 1
          เท่าหรือ 2 เท่าของภาษีที่ต้องชำระแล้วแต่กรณี <br /><br />

          เงินเบี้ยปรับดังกล่าวอาจลดหรืองดได้ตามระเบียบที่อธิบดีกำหนดโดยอนุมัติรัฐมนตรี
        </div>
      </div>

      <div class="pfb-detail">
        <div class="pfbd-sequence">3.</div>
        <div class="pfbd-description">
          กรณีไม่ยื่นแบบแสดงรายการ ภ.ง.ด. 90, 91 หรือ 94 ภายในกำหนดเวลา
          ต้องระวางโทษปรับ ทางอาญาไม่เกิน 2,000 บาท
        </div>
      </div>

      <div class="pfb-detail">
        <div class="pfbd-sequence">4.</div>
        <div class="pfbd-description">
          กรณีจงใจ แจ้งข้อความเท็จ หรือแสดงหลักฐาน เท็จหรือฉ้อโกง
          เพื่อหลีกเลี่ยงหรือพยายาม หลีกเลี่ยงการเสียภาษีอากร <br /><br />

          มีโทษจำคุกตั้งแต่ 3 เดือนถึง 7 ปี และปรับตั้งแต่ 2,000 บาท ถึง 200,000
          บาท
        </div>
      </div>

      <div class="pfb-detail">
        <div class="pfbd-sequence">5.</div>
        <div class="pfbd-description">
          กรณีเจตนาละเลยไม่ยื่นแบบแสดงรายการ เพื่อหลีกเลี่ยงการเสียภาษีอากร
          มีโทษปรับไม่เกิน 200,000 บาท หรือจำคุกไม่เกิน 1 ปี หรือทั้งจำทั้งปรับ
        </div>
      </div>
    </div>
  </template-info>
</template>

<script>
import BackgroundImg from "@/assets/images/infos/penalty_full.png";

export default {
  name: "PenaltyFull",
  components: {},
  data() {
    const bgImg = BackgroundImg;
    return {
      bgImg: bgImg,
    };
  },
  methods: {},
};
</script>

<style scoped>
.pfb-detail {
  width: 100%;
  color: #393d43;
  margin-bottom: 24px;
  text-align: left;
  display: flex;
  align-items: flex-start;
}
.pfbd-sequence {
  min-width: 28px;
}
</style>
